import { render } from "./settings-tab.vue?vue&type=template&id=092da8b2"
import script from "./settings-tab.vue?vue&type=script&lang=js"
export * from "./settings-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__